import type { Message } from '../types/message';
import type { PublicReport } from '../types/report';
import baseApi from './baseApi';

export interface PublicClientMessagesResponse {
  client: { firstName: string; lastName: string };
  messages: Message[];
}

const publicAccessApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPublicClientMessages: build.query<PublicClientMessagesResponse, { clientId: number; token: string }>({
      query: (props) => ({
        url: `/publicAccess/messages?clientId=${props.clientId}&token=${props.token}`,
        method: 'GET',
      }),
    }),
    getPublicReport: build.query<PublicReport, string>({
      query: (token: string) => ({
        url: `/publicAccess/report?token=${token}`,
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetPublicClientMessagesQuery, useGetPublicReportQuery } = publicAccessApi;
